import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BroadcastService } from '../../common/services/broadcast/broadcast.service';
import { ContextButtonService } from '../../common/services/context-button/context-button.service';
import { PortalEvents } from '../enums/portal-events.enum';
import { CommonEvents } from '../../common/enums/common-events.enum';
import { DashboardEvents } from '../../devices/dashboard/enums/dashboard-events.enum';
import { ResizedEvent } from 'angular-resize-event';
import { FavoriteService } from '../../favorite/services/favorite.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'cas-main-toolbar',
    templateUrl: './main-toolbar.component.html',
    styleUrls: ['./main-toolbar.component.scss']
})
export class MainToolbarComponent implements OnInit, AfterViewInit, OnDestroy {
    public isHidden: boolean;
    public hasContextButtons: boolean;
    public isFavoriteVisible;
    public isDefaultSearchButtonVisible: boolean;

    private isFavorite;

    @ViewChild('navbarWrapper', { static: false }) private navbarElementRef: ElementRef<HTMLElement> ;
    private searchStartedSubscription: Subscription;
    private visibleFavoriteSubscription: Subscription;
    private isFavoriteSubscription: Subscription;

    constructor(
        private broadcastService: BroadcastService,
        private contextButtonService: ContextButtonService,
        private favoriteService: FavoriteService
    ) {
    }

    public ngOnInit(): void {
        this.isDefaultSearchButtonVisible = this.contextButtonService.isDefaultSearchButtonVisible;
        this.searchStartedSubscription = this.broadcastService.on(PortalEvents.SearchStarted).subscribe((isHidden: boolean) => this.isHidden = isHidden);

        this.broadcastService.on(CommonEvents.ButtonPanel).subscribe(() => {
            this.hasContextButtons = this.contextButtonService.hasContextButtons();
            this.isDefaultSearchButtonVisible = this.contextButtonService.isDefaultSearchButtonVisible;
        });
    }

    public ngOnDestroy() {
        this.searchStartedSubscription?.unsubscribe();
        this.visibleFavoriteSubscription?.unsubscribe();
        this.isFavoriteSubscription?.unsubscribe();
    }

    public ngAfterViewInit(): void {
        this.contextButtonService.setNavbarPanelHeight(this.navbarElementRef.nativeElement.offsetHeight);
        this.subscribeToIsFavorite();
        this.subscribeToFavoriteVisible();
    }

    private subscribeToFavoriteVisible() {
        this.visibleFavoriteSubscription = this.broadcastService.on<string>(CommonEvents.VisibleFavorite)
            .subscribe(isFavoriteVisible => setTimeout(() => this.isFavoriteVisible = isFavoriteVisible));
    }

    private subscribeToIsFavorite() {
        this.isFavoriteSubscription = this.broadcastService.on<boolean>(DashboardEvents.IsFavorite)
            .subscribe(isFavorite => setTimeout(() => this.isFavorite = isFavorite));
    }

    public setFavorite() {
        this.favoriteService.changeFavorite();
    }

    public favoriteIcon() {
        return this.isFavorite ? 'star' : 'star_outlined';
    }

    public onResize($event: ResizedEvent) {
        this.contextButtonService.setNavbarPanelWidth($event.newWidth);
    }
}
